import InputContainer from "../../../../../common/InputContainer";
import "./moderatorAddDisplay.css";
import { useTranslation } from "react-i18next";

const ModeratorAddDisplay = ({
    handelKeyPressAddingModerator,
    newModeratorInput,
    setNewModeratorInput,
    inputDisplayMessage,
    isButtonDisabled,
    addModerator,
}) => {
    const { t } = useTranslation("moderatorPage");

    return (
        <div className="moderatorBroadcasterDisplayInput">
            <InputContainer
                onInput={(e) => setNewModeratorInput(e.target.value)}
                placeholder={t("addNewModeratorPlaceHolder")}
                buttonText={t("addModeratorButton")}
                buttonIsGray={isButtonDisabled}
                buttonOnClick={addModerator}
                messageText={inputDisplayMessage}
                onKeyPress={handelKeyPressAddingModerator}
                value={newModeratorInput}
            />
        </div>
    );
};

export default ModeratorAddDisplay;
